var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"pt-2"},[_c('b-button',{staticClass:"mb-5",attrs:{"size":"sm","variant":"outline-primary","to":`/users/${_vm.$route.params.id}/delivery-address`}},[_c('b-icon-arrow-left'),_vm._v(" К списку адресов ")],1),_c('item-info',{attrs:{"item-get-function":_vm.getDeliveryAddress,"fields":_vm.fields}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }